<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="username"
    :label="'Người chịu trách nhiệm'"
    :items="inCharges"
    return-object
    outlined
    @change="onChange"
    validate-on-blur
    v-model="selectedInCharge"
  ></v-autocomplete>
</template>

<script>
import { StudentTicket } from '@/plugins/api'

export default {
  data: () => ({
    inCharges: [],
    selectedInCharge: null,
  }),
  props: {
    inCharge: Object,
  },
  watch: {
    inCharge: {
      handler(newVal) {
        if (newVal) {
          this.selectedInCharge = newVal
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchAllInCharges()
  },
  methods: {
    async fetchAllInCharges() {
      this.inCharges = await StudentTicket.getInCharge({})
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
}
</script>
